import * as t from './types';
import { getWeatherAPI, getAdressAPI } from './api';
import { setTit } from '@/shared/utils';

export default {
  async setPrevTit({ commit }, b) {
    commit(t.SET_PREV_TIT, b);
    return b;
  },
  setNavigation({ commit }, b) {
    return commit(t.SET_NAVIGATION, b);
  },
  setReadyAction({ commit }, b) {
    return commit(t.SET_READYACTION, b);
  },
  async setStartProjectPop({ commit, dispatch, state }, b) {
    if (b) {
      await dispatch('setPrevTit', document.title);
      document.title = '프로젝트 문의 | PULIP';
    } else {
      setTit(state.prevTit);
    }
    return commit(t.SET_START_PROJECT_POP, b);
  },
  async setRecruitPop({ commit, dispatch, state }, b) {
    if (b) {
      await dispatch('setPrevTit', document.title);
      document.title = '채용문의 | PULIP';
    } else {
      setTit(state.prevTit);
    }
    return commit(t.SET_RECRUIT_POP, b);
  },
  async setPdsPop({ commit, dispatch, state }, b) {
    if (b) {
      await dispatch('setPrevTit', document.title);
      document.title = '디자인 시스템 | PULIP';
    } else {
      setTit(state.prevTit);
    }
    return commit(t.SET_PDS_POP, b);
  },
  setAwardsPop({ commit }, b) {
    return commit(t.SET_AWARDS_POP, b);
  },
  setCulturePop({ commit }, b) {
    return commit(t.SET_CULTURE_POP, b);
  },
  setPrivacyPolicyPop({ commit }, b) {
    return commit(t.SET_PRIVACY_POLICY_POP, b);
  },
  setLnbCopy({ commit }, s) {
    return commit(t.SET_LNB_COPY, s);
  },
  setIntro({ commit }, b) {
    return commit(t.SET_INTRO, b);
  },
  async getWeather({ commit }, payload) {
    try {
      commit(t.GET_WEATHER_PENDING);
      const response = await getWeatherAPI(payload);
      const { data: result = {} } = response;
      commit(t.GET_WEATHER_SUCCESS, { result });
      return response;
    } catch (error) {
      commit(t.GET_WEATHER_FAIL);
      throw err;
    }
  },
  async getAdress({ commit }, payload) {
    try {
      commit(t.GET_ADRESS_PENDING);
      const response = await getAdressAPI(payload);
      const { data: result = {} } = response;
      commit(t.GET_ADRESS_SUCCESS, { result });
      return response;
    } catch (err) {
      commit(t.GET_ADRESS_FAIL);
      throw err;
    }
  },

  async setPdsLnbAction({ commit }, payload) {
    try {
      commit(t.SET_PDS_LNB, payload);
      return payload;
    } catch (err) {
      console.error(`action setPdsLnbAction err : `, err);
    }
  },
  async setLoading({ commit }, payload) {
    commit(t.SET_LOADING, payload);
    return payload;
  }
};
